import { CallState, LoadingState } from '@lcs/shared/api';
import { Action, createReducer, on } from '@ngrx/store';
import { onReset } from 'src/app/authentication/reset-reducer';
import * as AddUserActions from './add-user.actions';

export const addUserFeatureKey = 'addUser';

export interface AddUserState {
   callState: CallState;
}

export const initialState: AddUserState = {
   callState: LoadingState.Init,
};

const addUserReducer = createReducer(
   initialState,
   onReset(initialState),
   on(AddUserActions.createUser, (state) => {
      return {
         ...state,
         callState: LoadingState.Loading,
      };
   }),
   on(AddUserActions.createUserSuccess, (state) => {
      return {
         ...state,
         callState: LoadingState.Loaded,
      };
   }),
   on(AddUserActions.createUserFailure, (state) => {
      return {
         ...state,
         callState: LoadingState.Loaded,
      };
   })
);

export function reducer(state: AddUserState | undefined, action: Action) {
   return addUserReducer(state, action);
}
